/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  import config from "../config/featuresSection.config.json";
  import {VApplication} from "../../../application";

  import { AppNavigatorService } from "../../appNavigatorService";

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};
  
  export interface IButtonMethods extends IPluginMethodMap {
    getButtonProps(args: any): Promise<any>;
  }
  
  export class ButtonService implements IAgentPlugin {
    readonly methods: IButtonMethods;
  
    constructor() {
      this.methods = {
        getButtonProps: this.getProps.bind(this),
      };
    }
  
    async getProps(args: any) {
        console.log(`button args in service`, args);
      //Business Logic -> args has backend response + config has static content
      return this.getButtons(args);
    }

    private async getButtons(args:any) {
        let whoami = await getWhoamiSrv()?.whoAmI();
        if(whoami?.whoami === "INSURANCE_PROVIDER" && !args?.purchaser?.bankDetails?.accHolderName && args?.status === "UNPAID"){
          return config?.button1;
        }
        if (whoami?.whoami === "INSURANCE_PROVIDER" && args?.status === "UNPAID" && args?.cyclone?.status === "ACCEPTED") {
          return config?.buttons;
        } else{
          return [];
        }
      }
  }
  